<template>
  <div id="Home">
    <!-- <Home /> -->
    <HomeTopImage />
    <EnquireyBanner />
    <BannerPrice /> 
    <template v-if="isMobile(true)">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2025/02/Flight_3.jpg">
    </template>
    <div id="about">
      <AboutTrackman />
    </div>
    <template v-if="isMobile(true)">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2025/02/Flight_5.jpg">
    </template>
    <template v-else>
      <GolfParkImages />
    </template>
    <div id="membership">
      <GolfMember />
    </div>
     <div class="AppSection">
      <b-container>
        <template v-if="isMobile(true)">
          <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
            <img class="BookNowApp" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/BookNOw_Mobile_Banner_2-1.png">
            <b-row>
              <b-col>
              </b-col>
              <b-col>
                <b-row cols="placementmob">
                  <b-col>
                    <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="BookNowAppAppleMob" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/AppleAppStore.png">
                    </b-link>
                  </b-col>
                  <b-col>
                    <b-link :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="BookNowAppGoogleMob" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/GooglePlay.png">
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-link>
        </template>
        <template v-else>
          <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
            <img class="BookNowApp" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2024/11/DownloadAppBanner_1.png">
            <b-row>
              <b-col>
              </b-col>
              <b-col>
                <b-row cols="placement">
                  <b-col>
                    <b-link :href="'https://apps.apple.com/gb/app/sim-park/id6738054804'" target="_blank">
                      <img class="BookNowAppApple" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/AppleAppStore.png">
                    </b-link>
                  </b-col>
                  <b-col>
                    <b-link :href="'https://play.google.com/store/apps/details?id=com.ocssoftware.simpark.app'" target="_blank">
                      <img class="BookNowAppGoogle" src="https://wp-ocssport.ocs-sport.com/golfpark/wp-content/uploads/sites/4/2024/11/GooglePlay.png">
                    </b-link>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-link>
        </template>
      </b-container>
    </div>   
    <div class="questionsSection">
       <Questions />
    </div>
    <template v-if="isMobile(true)">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2025/02/Flight_4.jpg">
      <img class="imagesInsert" src="https://wp-ocssport.ocs-sport.com/flightpark/wp-content/uploads/sites/6/2025/02/Flight_6.jpg">
    </template>
  </div>
</template>

<script>
import HomeTopImage from '@/components/HomeTopImage.vue'
import EnquireyBanner from '@/components/EnquireyBannerOne.vue'
import AboutTrackman from '@/components/AboutTrackman.vue'
import GolfParkImages from '@/components/GolfParkImages.vue'
import GolfMember from '@/components/GolfParkMember.vue'
import Questions from '@/components/QuestionandAnswers.vue'
import BannerPrice from '@/components/BannerPrice.vue'
export default {
  name: 'App',
  components: {
    HomeTopImage,
    EnquireyBanner,
    AboutTrackman,
    GolfParkImages,
    GolfMember,
    Questions,
    BannerPrice
  },
  methods: {
    isMobile() {
        if( screen.width <= 768 ) {
            return true;
        }
        else {
            return false;
        }
    },
  }
}
</script>
<style scoped>
  .pulse {
    animation: pulse-red 2s infinite;
  }

  @keyframes pulse-red {
    0% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }

    50% {
      -webkit-transform: scale(1.2);
      transform: scale(1.2);
    }

    100% {
      -webkit-transform: scale(1);
      transform: scale(1);
    }
  }
  .buyGiftVoucher {
    background-color: #d80e1f;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 458px;
    height: 57px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    position: absolute;
    top: 10.5em;
    z-index: 99;
    margin-left: 10em;
    cursor: pointer;
  }
  .buyGiftVoucher:hover {
    background-color: #000000;
    border-color: #d80e1f !important;
    border-radius: 50px;
    width: 163px;
    height: 31px;
    line-height: 1;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    width: 458px;
    height: 57px;
    /* margin-top: 65px; */
    font-family: "noto-sans", sans-serif;
    border: none;
    position: absolute;
    top: 10.5em;
    z-index: 99;
    margin-left: 10em;
    cursor: pointer;
  }
  img.BookNowAppApple {
    width: 220px;
  }
  img.BookNowAppGoogle {
    width: 220px;
  }
  .row.row-cols-placement {
    position: absolute;
    top: -9em;
    left: 8em;
  }
  .AppSection {
    padding-bottom: 100px;
  }
  ::v-deep .btn-danger {
    color: #fff;
    background-color: #7ebd63;
    border-color: #7ebd63!important;
  }
  .imagesInsert {
    width: 100%;
  }
  .BookNowApp {
    width: 100%;
  }
  @media only screen and (max-width: 1280px) {
    .buyGiftVoucher {
        background-color: #d80e1f;
        border-color: #d80e1f !important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 458px;
        height: 57px;
        /* margin-top: 65px; */
        font-family: "noto-sans", sans-serif;
        border: none;
        position: absolute;
        top: 10.5em;
        z-index: 99;
        margin-left: 5em;
        cursor: pointer;
    }
    .buyGiftVouche:hover {
        background-color: #000000;
        border-color: #000000 !important;
        border-radius: 50px;
        width: 163px;
        height: 31px;
        line-height: 1;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        width: 458px;
        height: 57px;
        /* margin-top: 65px; */
        font-family: "noto-sans", sans-serif;
        border: none;
        position: absolute;
        top: 10.5em;
        z-index: 99;
        margin-left: 5em;
        cursor: pointer;
    }
  }
  @media only screen and (max-width: 1260px) {
    .row.row-cols-placement {
      position: absolute;
      top: -8em;
      left: 6em;
    } 
  }
  @media only screen and (max-width: 1230px) {
    .row.row-cols-placement {
      position: absolute;
      top: -8em;
      left: 6em;
    } 
  }
  @media only screen and (max-width: 1200px) {
    img.BookNowAppGoogle {
      width: 160px;
    }
    img.BookNowAppApple{
      width: 160px;
    }
    .row.row-cols-placement {
      position: absolute;
      top: -6.5em;
      left: 6em;
    } 
  }
  @media only screen and (max-width: 990px) {
    img.BookNowAppGoogle {
      width: 110px;
    }
    img.BookNowAppApple{
      width: 110px;
    }
    .row.row-cols-placement {
      position: absolute;
      top: -4.5em;
      left: 4em;
    } 
  }

  /* mobileAd */
  .row.row-cols-placementmob {
    position: absolute;
    top: -6.5em;
    left: -5em;
  } 
  img.BookNowAppGoogleMob {
    width: 150px;
  }
  img.BookNowAppAppleMob{
    width: 150px;
  }
  @media only screen and (max-width: 767px) {
    img.BookNowAppAppleMob {
      width: 110px;
    }
    img.BookNowAppGoogleMob{
      width: 110px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -4.5em;
      left: -4em;
    } 
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 458px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 10.5em;
      z-index: 99;
      margin-left: 7em;
      cursor: pointer;
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 458px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 10.5em;
      z-index: 99;
      margin-left: 7em;
      cursor: pointer;
      left: 0;
      right: 0;
    }
  }
  @media only screen and (max-width: 500px) {
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
  }
  @media only screen and (max-width: 425px) {
    img.BookNowAppAppleMob {
      width: 100px;
    }
    img.BookNowAppGoogleMob{
      width: 100px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -3.6em;
      left: -4em;
    } 
  }
  @media only screen and (max-width: 396px) {
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 2.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 303px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 2.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    } 
  }
  @media only screen and (max-width: 375px) {
    img.BookNowAppAppleMob {
      width: 80px;
    }
    img.BookNowAppGoogleMob{
      width: 80px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -3.1em;
      left: -3.5em;
    } 
    .buyGiftVoucher {
      background-color: #d80e1f;
      border-color: #d80e1f !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 243px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
    .buyGiftVoucher:hover {
      background-color: #000000;
      border-color: #000000 !important;
      border-radius: 50px;
      width: 163px;
      height: 31px;
      line-height: 1;
      color: #fff;
      font-size: 18px;
      font-weight: bold;
      width: 243px;
      height: 57px;
      /* margin-top: 65px; */
      font-family: "noto-sans", sans-serif;
      border: none;
      position: absolute;
      top: 8em;
      z-index: 99;
      margin-left: 3.5em !important;
      cursor: pointer;
      /* float: left; */
      left: 0;
      right: 0;
    }
  }
  @media only screen and (max-width: 320px) {
    img.BookNowAppAppleMob {
      width: 60px;
    }
    img.BookNowAppGoogleMob{
      width: 60px;
    }
    .row.row-cols-placementmob {
      position: absolute;
      top: -2.7em;
      left: -2.6em;
    } 
  }
</style>

